const initialState = {
  addActive: false,
  removeActive: false,
  filterValue: '',
  selectedLanguages: [],
  allLanguages: [],
  preferredLanguages: []
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_ALL_LANGUAGES_FULFILLED':
      action.myThis.setState({ preferredLanguages: action.payload.preferred });
      return { ...state, allLanguages: action.payload.content_languages, preferredLanguages: action.payload.preferred };
    case 'UPDATE_LANGUAGE_FILTER_VALUE':
      return { ...state, filterValue: action.payload };
    case 'ADD_PREFERED_LANGUAGE':
      action.myThis.setState({ preferredLanguages: [...state.preferredLanguages, ...action.payload] });
      return {
        ...state,
        preferredLanguages: [...state.preferredLanguages, ...action.payload],
        allLanguages: state.allLanguages.filter(lang => !action.payload.map(x => x.iso_code).includes(lang.iso_code))
      };
    case 'REMOVE_PREFERED_LANGUAGE':
      action.myThis.setState({ preferredLanguages: state.preferredLanguages.filter(lang => lang.iso_code !== action.payload) });
      return {
        ...state,
        preferredLanguages: state.preferredLanguages.filter(lang => lang.iso_code !== action.payload),
        allLanguages: [
          ...state.allLanguages,
          ...state.preferredLanguages.filter(lang => lang.iso_code === action.payload)
        ].sort((l1, l2) => (l1.name < l2.name ? -1 : (l1.name > l2.name ? 1 : 0)))
      };
    case 'UPDATE_PREFERED_LANGUAGES':
      return { ...state, preferredLanguages: action.payload };
    case 'UPDATE_SELECTED_LANGUAGES':
      return { ...state, selectedLanguages: action.payload };
    case 'UPDATE_ADD_BUTTON':
      return { ...state, addActive: action.payload };
    case 'UPDATE_REMOVE_BUTTON':
      return { ...state, removeActive: action.payload };
    default:
      return state;
  }
}
